import gql from 'graphql-tag';

export const getClientCountryQL = gql`
  query($clientId: ID!) {
    client(id: $clientId) {
      id
      country
    }
  }
`;

export const getLastJobQL = gql`
  query($projectId: ID!) {
    lastJob(project: $projectId) {
      id
      products {
        id
      }
    }
  }
`;
